//#. Vuex Type Script
//#. Version		          : 1.0.0.0
//#. Template Modified Date : 12-MAR-2020 10:00:00 AM
//#. File Created Date      : 12-MAR-2020 10:00:00 AM
import { Module } from "vuex";
import { RootState } from "../../../../types";
import { Announcement } from "./types";
import { getters } from './getters';
import { mutations } from "./mutations";
import { actions } from "./actions";
const namespaced: boolean = true;

//#. An object containing the data
export const state: Announcement = {
    enabled: true,
    itemsPerPage: 1000,
    items: [],
    snackbar: false,
    text: 'The Announcement is deleted successfully.'
};

export const RootAnnouncement: Module<Announcement, RootState> = {
    namespaced,
    state,
    getters,
    mutations,
    actions,
};